module.exports = __webpack_public_path__ + "static/media/capitalsphere_sp0.e727474d.jpg";